/*global module */
module.exports = {};
module.exports.default = {
    'name': 'Software Development Theme',
    'layout': {
        'orientation': 'top-down',
        'spacing': {
            'h': 20,
            'v': 100
        }
    },
    'node': [
        {
            'name': 'default',
            'cornerRadius': 5.0,
            'background': {
                'color': '#f0f0f0',
                'opacity': 1.0
            },
            'border': {
                'type': 'underline',
                'line': {
                    'color': '#4a90e2',
                    'width': 2.0
                }
            },
            'text': {
                'margin': 5.0,
                'alignment': 'center',
                'color': '#4a90e2',
                'lightColor': '#FFFFFF',
                'darkColor': '#000000',
                'font': {
                    'lineSpacing': 2,
                    'size': 12,
                    'weight': 'normal'
                }
            }
        },
        {
            'name': 'attr_group_Bug',
            'background': {
                'color': '#e94e77',
                'opacity': 1.0
            },
            'text': {
                'color': '#FFFFFF'
            }
        },
        {
            'name': 'attr_group_Feature',
            'background': {
                'color': '#4a90e2',
                'opacity': 1.0
            },
            'text': {
                'color': '#FFFFFF'
            }
        },
        {
            'name': 'attr_group_In_Progress',
            'background': {
                'color': '#f5a623',
                'opacity': 1.0
            },
            'text': {
                'color': '#FFFFFF'
            }
        }
    ],
    'connector': {
        'default': {
            'type': 'vertical-quadratic-s-curve',
            'line': {
                'color': '#707070',
                'width': 1.0
            }
        }
    }
};
